import { render, staticRenderFns } from "./AppColorPicker.vue?vue&type=template&id=ca5316a6&scoped=true&"
import script from "./AppColorPicker.vue?vue&type=script&lang=js&"
export * from "./AppColorPicker.vue?vue&type=script&lang=js&"
import style0 from "./AppColorPicker.vue?vue&type=style&index=0&id=ca5316a6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca5316a6",
  null
  
)

export default component.exports
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QPopupProxy from 'quasar/src/components/popup-proxy/QPopupProxy.js';
import QColor from 'quasar/src/components/color/QColor.js';
import QField from 'quasar/src/components/field/QField.js';
import qInstall from "../../@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(component, 'components', {QIcon,QPopupProxy,QColor,QField});
